import { io, Socket } from 'socket.io-client'

import PipelineSocket from './PipelineSocket'
import LabelingSocket from './LabelingSocket'

export default class SocketClient {
  socket: Socket

  Pipeline: PipelineSocket

  Labeling: LabelingSocket

  constructor(serverUrl: string) {
    this.socket = io(serverUrl)
    this.Pipeline = new PipelineSocket(this.socket)
    this.Labeling = new LabelingSocket(this.socket)
  }

  connect(): void {
    this.socket.connect()
  }

  disconnect(): void {
    this.socket.disconnect()
  }

  on(event: string, callback: (data: any) => void): void {
    this.socket.on(event, callback)
  }

  emit(event: string, data?: any) {
    this.socket.emit(event, data)
  }

  off(event: string, callback?: (data: any) => void): void {
    this.socket.off(event, callback)
  }
}
